<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre2"> <span class="calibre3">Orphans </span> </p>
<p class="calibre2"> <span class="calibre3">Preferred</span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre2"> <span class="calibre6">Renée Vajko Srch</span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre7"> <span class="calibre8"> </span> </p>
<p class="calibre7"> <span class="calibre8"> </span> </p>
<p class="calibre7"> <span class="calibre8">Illustrated by Faythe Payol</span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <img alt="" class="calibre9" src="images/00001.jpeg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000.vue?a94d0f24